<template>
  <div class="expos-container q-pa-md">
    <div class="section-container">
      <h3 class="text-h4 text-weight-bold q-mb-lg" style="color: #9a9a9b;">Vos expositions</h3>
      <div class="row q-col-gutter-md">
        <q-banner v-if="success" class="col-12 app-banner app-banner--success" dense rounded>
          {{ successMessage }}
        </q-banner>
        <q-banner v-if="saveError" class="col-12 app-banner app-banner--error" dense rounded>
          Erreur lors de l'enregistrement
        </q-banner>
        <div v-for="exhibit in exhibits" :key="exhibit.id" class="col-12 col-sm-6 col-md-4">
          <q-card class="expo-card">
            <q-img 
              loading="lazy" 
              class="expo-image" 
              height="250px" 
              spinner-size="82px" 
              spinner-color="primary"
              :src="homeImageUrls[exhibit.id]"
              @error="onImageError(exhibit.id)"
            >
              <template v-slot:error>
                <div class="default-image-container bg-grey-3">
                  <q-icon name="image" size="80px" color="grey-7" />
                  <div class="text-grey-7 text-caption q-mt-sm">Aucune image disponible</div>
                </div>
              </template>
              <div class="absolute-bottom text-subtitle2 text-center bg-white" style="color: #c0c0c1; font-weight: bold; font-size: 1.2rem;">
                {{ exhibit.name }}
              </div>
            </q-img>
            <q-card-actions align="center" class="q-pa-md">
              <q-btn :style="{ backgroundColor: '#8257d4', color: 'white' }" label="Accéder" icon="launch" @click="navigate(exhibit.id)" />
              <q-btn-dropdown color="grey" icon="more_vert" flat>
                <q-list>
                  <q-item clickable v-close-popup @click="openModifDialog(exhibit.id)">
                    <q-item-section avatar>
                      <q-icon name="edit" color="primary"/>
                    </q-item-section>
                    <q-item-section>Modifier</q-item-section>
                  </q-item>
                  <q-item clickable v-close-popup @click="duplicateExhibit(exhibit.id)">
                    <q-item-section avatar>
                      <q-icon name="content_copy" color="primary"/>
                    </q-item-section>
                    <q-item-section>Dupliquer</q-item-section>
                  </q-item>
                  <q-item v-if="isAdmin" clickable v-close-popup @click="archiveExhibit(exhibit.id)">
                    <q-item-section avatar>
                      <q-icon name="archive" color="warning"/>
                    </q-item-section>
                    <q-item-section >Archiver</q-item-section>
                  </q-item>
                  <q-item v-if="isAdmin" clickable v-close-popup @click="openChangeOwnerDialog(exhibit.id)">
                    <q-item-section avatar>
                      <q-icon name="people" color="info"/>
                    </q-item-section>
                    <q-item-section>Changer le propriétaire</q-item-section>
                  </q-item>
                  <q-item v-if="canDelete(exhibit.id)" clickable v-close-popup @click="deleteExhibit(exhibit.id)">
                    <q-item-section avatar>
                      <q-icon name="delete" color="negative"/>
                    </q-item-section>
                    <q-item-section>Supprimer</q-item-section>
                  </q-item>
                </q-list>
              </q-btn-dropdown>
            </q-card-actions>
            <q-inner-loading showing color="primary" v-if="loading" />
          </q-card>
        </div>
      </div>
    </div>

    <div class="section-container q-mt-xl">
      <h3 class="text-h4 text-weight-bold q-mb-lg" style="color: #9a9a9b;">Toutes les expositions</h3>
      <div class="row q-col-gutter-md">
        <div v-for="exhibit in allExhibits" :key="exhibit.id" class="col-12 col-sm-6 col-md-4">
          <q-card class="expo-card">
            <q-img 
              loading="lazy" 
              class="expo-image" 
              height="250px" 
              spinner-size="82px" 
              spinner-color="primary"
              :src="homeImageUrls[exhibit.id]"
              @error="onImageError(exhibit.id)"
            >
              <template v-slot:error>
                <div class="default-image-container bg-grey-3">
                  <q-icon name="image" size="80px" color="grey-7" />
                  <div class="text-grey-7 text-caption q-mt-sm">Aucune image disponible</div>
                </div>
              </template>
              <div class="absolute-bottom text-subtitle2 text-center bg-white" style="color: #c0c0c1; font-weight: bold; font-size: 1.2rem;">
                {{ exhibit.name }}
              </div>
            </q-img>
            <q-card-actions align="center" class="q-pa-md">
              <q-btn :style="{ backgroundColor: '#8257d4', color: 'white' }"  label="Accéder" icon="launch" @click="navigate(exhibit.id)" />
              <q-btn-dropdown color="grey" icon="more_vert" flat>
                <q-list>
                  <q-item clickable v-close-popup @click="openModifDialog(exhibit.id)">
                    <q-item-section avatar>
                      <q-icon name="edit" color="primary"/>
                    </q-item-section>
                    <q-item-section>Modifier</q-item-section>
                  </q-item>
                  <q-item clickable v-close-popup @click="duplicateExhibit(exhibit.id)">
                    <q-item-section avatar>
                      <q-icon name="content_copy" color="primary"/>
                    </q-item-section>
                    <q-item-section>Dupliquer</q-item-section>
                  </q-item>
                  <q-item v-if="isAdmin" clickable v-close-popup @click="archiveExhibit(exhibit.id)">
                    <q-item-section avatar>
                      <q-icon name="archive" color="warning"/>
                    </q-item-section>
                    <q-item-section>Archiver</q-item-section>
                  </q-item>
                  <q-item v-if="isAdmin" clickable v-close-popup @click="openChangeOwnerDialog(exhibit.id)">
                    <q-item-section avatar>
                      <q-icon name="people" color="info"/>
                    </q-item-section>
                    <q-item-section>Changer le propriétaire</q-item-section>
                  </q-item>
                  <q-item v-if="canDelete(exhibit.id)" clickable v-close-popup @click="deleteExhibit(exhibit.id)">
                    <q-item-section avatar>
                      <q-icon name="delete" color="negative"/>
                    </q-item-section>
                    <q-item-section>Supprimer</q-item-section>
                  </q-item>
                </q-list>
              </q-btn-dropdown>
            </q-card-actions>
            <q-inner-loading showing color="primary" v-if="loading" />
          </q-card>
        </div>
      </div>
    </div>

    <q-dialog v-model="modifDialog">
      <q-card style="min-width: 350px">
        <q-card-section class="row items-center q-pb-none">
          <div class="text-h6">Modifier le nom de l'exposition</div>
          <q-space />
          <q-btn icon="close" flat round dense v-close-popup />
        </q-card-section>

        <q-card-section>
          <q-input 
            dense 
            v-model="newExhibitName" 
            label="Nouveau nom"
            autofocus 
            :rules="[val => !!val || 'Le nom est requis']"
          />
        </q-card-section>

        <q-card-actions align="right" class="text-primary">
          <q-btn flat label="Annuler" v-close-popup />
          <q-btn flat label="Modifier" @click="modifyExhibitName" v-close-popup />
        </q-card-actions>
      </q-card>
    </q-dialog>

    <!-- Modal pour changer le propriétaire -->
    <q-dialog v-model="changeOwnerDialog">
      <q-card style="min-width: 400px">
        <q-card-section class="row items-center q-pb-none">
          <div class="text-h6">Changer le propriétaire</div>
          <q-space />
          <q-btn icon="close" flat round dense v-close-popup />
        </q-card-section>

        <q-card-section>
          <div class="q-mb-md">
            <p class="text-subtitle2">Propriétaire actuel: <span class="text-weight-bold">{{ currentOwnerName }}</span></p>
          </div>
          <q-select
            dense
            v-model="newOwnerId"
            :options="userOptions"
            label="Nouveau propriétaire"
            option-label="label"
            option-value="value"
            map-options
            emit-value
            :rules="[val => !!val || 'Veuillez sélectionner un utilisateur']"
          />
        </q-card-section>

        <q-card-actions align="right" class="text-primary">
          <q-btn flat label="Annuler" v-close-popup />
          <q-btn flat label="Changer" @click="changeExhibitOwner" :loading="loading" />
        </q-card-actions>
      </q-card>
    </q-dialog>
  </div>
</template>

<script>
import axios from "axios";
import { useStore } from "vuex";
import { ref, onMounted, computed } from "vue";
import { useRouter } from "vue-router";

// Image de repli des vignettes d'exposition : une exposition sans image
// d'accueil, ou dont l'image n'a pas pu être chargée.
//
// Elle est en ligne plutôt que servie par un tiers. Les deux services employés
// ici auparavant le montrent : via.placeholder.com ne répond plus du tout
// (vérifié le 2026-09-21, la connexion est fermée aussitôt) et remplissait la
// liste d'images cassées ; picsum.photos, lui, répond encore, mais il servait
// la branche d'erreur — c'est-à-dire précisément le cas où le réseau vient de
// faire défaut. Une image en ligne n'ajoute aucune requête et ne peut pas
// tomber.
const IMAGE_DE_REPLI =
  "data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%22200%22%20height%3D%22300%22%20viewBox%3D%220%200%20200%20300%22%3E%3Crect%20width%3D%22200%22%20height%3D%22300%22%20fill%3D%22%23eeeeee%22%2F%3E%3Crect%20x%3D%2255%22%20y%3D%22115%22%20width%3D%2290%22%20height%3D%2270%22%20fill%3D%22none%22%20stroke%3D%22%239e9e9e%22%20stroke-width%3D%224%22%2F%3E%3Ccircle%20cx%3D%2280%22%20cy%3D%22138%22%20r%3D%228%22%20fill%3D%22%239e9e9e%22%2F%3E%3Cpath%20d%3D%22M59%20181%20L88%20152%20L110%20174%20L125%20162%20L141%20181%20Z%22%20fill%3D%22%239e9e9e%22%2F%3E%3C%2Fsvg%3E";

export default {

  setup() {
    const exhibits = ref([]);
    const userId = ref("");
    const allExhibits = ref([]);
    const store = useStore();
    const router = useRouter();
    const homeImageUrls = ref({});
    const newExhibitName = ref();
    const exhibitSelectedId = ref();
    const modifDialog = ref(false);
    const success = ref(false);
    const successMessage = ref("");
    const saveError = ref(false);
    const loading = ref(false);
    const changeOwnerDialog = ref(false);
    const exhibitToChangeOwner = ref(null);
    const newOwnerId = ref(null);
    const users = ref([]);
    const userOptions = ref([]);
    const currentOwnerName = ref("");
    const currentOwnerId = ref(null);
    const navigate = (id) => {
      router.push({ path: "/expo/" + id });
    };

    const isAdmin = computed(() => {
      return store.state.adminIds.includes(store.state.userId)

    });

    const canDelete = (exhibitId) =>{
      //Un utilisateur peut supprimer une exposition si il fait partie du pole numérique ou si c'est lui qui
      //a créé l'exposition
      var result = false;
      if(exhibits.value.some(exhibit=>exhibit.id == exhibitId)){
        result=true;
      }
      var polNumIds = [1, 3, 6, 405];
      var userId = store.state.userId;
      if(polNumIds.includes(userId)){
        result=true;
      }
      return result;
    }


    const deleteExhibit = async (id) => {
      try {
        if (confirm('Êtes-vous sûr de vouloir supprimer cette exposition ?')) {
          loading.value = true;
          let url = `${process.env.VUE_APP_BASEURL}/exhibit`;
          await axios.delete(url, {
            data: { userId: store.state.userId, exhibitId: id },
          });
          success.value = true;
          successMessage.value = "L'exposition a été supprimée avec succès";
          setTimeout(() => {
            success.value = false;
          }, 4000);
          await getExhibits();
        }
      } catch (error) {
        console.error('Erreur lors de la suppression:', error);
        saveError.value = true;
        setTimeout(() => {
          saveError.value = false;
        }, 4000);
      } finally {
        loading.value = false;
      }
    };

    

    const loadHomeFilesForExhibits = async () => {
      let exhibitsComplete = [...allExhibits.value, ...exhibits.value]
        .filter((exhibit, index, self) =>
          index === self.findIndex((e) => (
            e.id === exhibit.id
          ))
        );

      // Créez un tableau de promesses pour chaque exposition
      const imagePromises = exhibitsComplete.map(async (exhibit) => {
        try {
          let url = `${process.env.VUE_APP_BASEURL}/exhibit_home/${exhibit.id}`;
          let response = await axios.get(url);

          // Vérifiez si une image d'accueil a été trouvée
          if (response.data.length > 0) {
            let homeImage = response.data[0];
            let name = homeImage.name;
            let url1 = `${process.env.VUE_APP_BASEURL}/s3Resource/${name}`;
            let response1 = await axios.get(url1);
            var base64data = response1.data;

            homeImageUrls.value[exhibit.id] = base64data;
          } else {
            homeImageUrls.value[exhibit.id] = IMAGE_DE_REPLI; // pas d'image d'accueil
          }
        } catch (error) {
          console.log(error);
          homeImageUrls.value[exhibit.id] = IMAGE_DE_REPLI; // le chargement a échoué
        }
      });

      // Exécutez toutes les promesses en parallèle
      await Promise.all(imagePromises);
    }



    const getExhibits = async () => {
      try {
        // Récupérer d'abord les archives pour les exclure
        const archiveUrl = `${process.env.VUE_APP_BASEURL}/archive-exhibits`;
        const archiveResponse = await axios.get(archiveUrl);
        const archivedIds = archiveResponse.data.map(archive => archive.exhibit_id);

        // Récupérer les expositions de l'utilisateur
        let url = `${process.env.VUE_APP_BASEURL}/exhibits/${store.state.userId}`;
        try {
          let response = await axios.get(url);
          // Filtrer pour exclure les expositions archivées
          exhibits.value = response.data.filter(exhibit => !archivedIds.includes(exhibit.id));
          userId.value = store.state.userId;
        } catch (err) {
          if (err.response && err.response.status === 404) {
            exhibits.value = [];
          } else {
            throw err;
          }
        }

        // Récupération de toutes les expositions
        let url2 = `${process.env.VUE_APP_BASEURL}/exhibits`;
        let response2 = await axios.get(url2);
        // Filtrer pour exclure les expositions archivées et celles de l'utilisateur
        let difference = response2.data
          .filter(a1 => !archivedIds.includes(a1.id))
          .filter(a1 => !exhibits.value.find(a2 => a1.id === a2.id));
        allExhibits.value = difference;

      } catch (error) {
        console.log('Erreur lors de la récupération des expositions :', error);
      }
    }


    const modifyExhibitName = async () => {
      try {
        let url = `${process.env.VUE_APP_BASEURL}/exhibit/${exhibitSelectedId.value}/${newExhibitName.value}`;
        await axios.put(url);
        success.value = true;
        successMessage.value = "Données enregistrées avec succès";
        setTimeout(() => {
          success.value = false;
          modifDialog.value = false;
          exhibitSelectedId.value = "";
          newExhibitName.value = "";
          start();
        }, 1500);

      } catch (error) {
        console.log(error);
        saveError.value = true;
        setTimeout(() => {
          saveError.value = false;
        }, 1500);
      }
    }

    const openModifDialog = (id) => {
      exhibitSelectedId.value = id;
      modifDialog.value = true;
    }

    const start = async () => {
      await getExhibits();
      await loadHomeFilesForExhibits();
    }

    const duplicateExhibit = async (id) => {
      console.log(id);
      let url = `${process.env.VUE_APP_BASEURL}/duplicate`;
      await axios.post(url, {exhibitId: id, userId: store.state.userId});
      //Afficher le loading
      loading.value = true;
      setTimeout(async () => {
        await getExhibits();
      }, 1000);
      setTimeout(async () => {
        await loadHomeFilesForExhibits();
      }, 2000);
      //Masquer le loading
      loading.value = false;
    }

    const archiveExhibit = async (id) => {
      try {
        if (confirm('Êtes-vous sûr de vouloir archiver cette exposition ?')) {
          loading.value = true;
          const url = `${process.env.VUE_APP_BASEURL}/archive-exhibit`;
          await axios.post(url, { exhibit_id: id });
          success.value = true;
          successMessage.value = "L'exposition a été archivée avec succès";
        setTimeout(() => {
          success.value = false;
        }, 4000);
          // Rafraîchir la liste des expositions
          await getExhibits();
        }
      } catch (error) {
        console.error('Erreur lors de l\'archivage:', error);
        saveError.value = true;
        setTimeout(() => {
          saveError.value = false;
        }, 4000);
      } finally {
        loading.value = false;
      }
    };

    const loadUsers = async () => {
      try {
        // Récupérer les associations utilisateur-exposition
        const userExhibitsUrl = `${process.env.VUE_APP_BASEURL}/user-exhibits`;
        const userExhibitsResponse = await axios.get(userExhibitsUrl);
        users.value = userExhibitsResponse.data;

        // Récupérer la liste complète des utilisateurs pour le sélecteur
        const usersUrl = `${process.env.VUE_APP_BASEURL}/users`;
        const usersResponse = await axios.get(usersUrl);
        
        // Créer un tableau d'utilisateurs uniques pour le dropdown
        userOptions.value = usersResponse.data.map(user => ({
          label: user.name,
          value: user.id
        }));
      } catch (error) {
        console.error('Erreur lors du chargement des utilisateurs:', error);
      }
    };

    const openChangeOwnerDialog = async (exhibitId) => {
      exhibitToChangeOwner.value = exhibitId;
      
      // Trouver l'information sur le propriétaire actuel dans les associations user-exhibit
      const userExhibit = users.value.find(ue => parseInt(ue.exhibit_id) === parseInt(exhibitId));
      
      if (userExhibit) {
        currentOwnerName.value = userExhibit.user_name;
        currentOwnerId.value = parseInt(userExhibit.user_id);
        
        // Pré-sélectionner l'utilisateur actuel dans le dropdown
        newOwnerId.value = parseInt(userExhibit.user_id);
      } else {
        console.error(`Aucun propriétaire trouvé pour l'exposition ${exhibitId}`);
        // Définir des valeurs par défaut pour éviter des erreurs
        currentOwnerName.value = "Propriétaire inconnu";
        currentOwnerId.value = null;
      }
      
      changeOwnerDialog.value = true;
    };

    const changeExhibitOwner = async () => {
      try {
        // Vérification des données
        if (!newOwnerId.value) {
          console.error('Nouveau propriétaire non sélectionné');
          return;
        }
        
        if (!exhibitToChangeOwner.value) {
          console.error('ID de l\'exposition manquant');
          return;
        }
        
        if (!currentOwnerId.value) {
          console.error('ID du propriétaire actuel manquant');
          return;
        }

        loading.value = true;
        const url = `${process.env.VUE_APP_BASEURL}/user-exhibit/exhibit/${exhibitToChangeOwner.value}`;
        
        console.log('Envoi de la requête avec les données:', {
          oldUserId: currentOwnerId.value,
          newUserId: newOwnerId.value,
          exhibitId: exhibitToChangeOwner.value
        });
        
        await axios.put(url, {
          oldUserId: currentOwnerId.value,
          newUserId: newOwnerId.value
        });
        
        success.value = true;
        successMessage.value = "Le propriétaire de l'exposition a été modifié avec succès";
        setTimeout(() => {
          success.value = false;
          changeOwnerDialog.value = false;
          newOwnerId.value = null;
          exhibitToChangeOwner.value = null;
          currentOwnerName.value = "";
          currentOwnerId.value = null;
        }, 3000);
        
        // Rafraîchir les données
        await loadUsers();
        await getExhibits();
      } catch (error) {
        console.error('Erreur lors du changement de propriétaire:', error);
        saveError.value = true;
        setTimeout(() => {
          saveError.value = false;
        }, 3000);
      } finally {
        loading.value = false;
      }
    };

    const onImageError = (exhibitId) => {
      // Si l'image ne charge pas, on met une URL par défaut
      homeImageUrls.value[exhibitId] = null;
    };

    onMounted(async () => {
      await start();
      if (isAdmin.value) {
        await loadUsers();
      }
    });

    return {
      exhibits,
      allExhibits,
      homeImageUrls,
      newExhibitName,
      modifDialog,
      success,
      successMessage,
      saveError,
      loading,
      navigate,
      canDelete,
      deleteExhibit,
      duplicateExhibit,
      openModifDialog,
      modifyExhibitName,
      onImageError,
      archiveExhibit,
      isAdmin,
      changeOwnerDialog,
      newOwnerId,
      userOptions,
      currentOwnerName,
      openChangeOwnerDialog,
      changeExhibitOwner
    };
  },
};
</script>

<style scoped>
.expos-container {
  max-width: 1400px;
  margin: 0 auto;
}

.section-container {
  background: white;
  border-radius: 8px;
  padding: 2rem;
  box-shadow: 0 1px 5px rgba(0, 0, 0, 0.1);
}

.expo-card {
  transition: transform 0.2s, box-shadow 0.2s;
  height: 100%;
}

.expo-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
}

.expo-image {
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
}

.default-image-container {
  height: 250px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.banner {
  border-radius: 4px;
  margin-bottom: 1rem;
}
</style>
